import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'ja',
        lng: localStorage.getItem('i18nextLng') || 'ja',
        debug: false,
        interpolation: {
            escapeValue: false,
            formatSeparator: ',',
        },
        ns: [
            'common',
            'navigation',
            'login',
            'daily-report',
            'total-of-all-store',
            'revenue',
            'customer',
            'store-bulletin-of-sbs',
            'fees-register',
            'staff',
            'seat-list-close',
            'seat-report-monthly',
            'seat-usage-history',
            'seat-register-close',
            'seat-update-close',
            'seat-usage',
            'discount',
            'product-register',
            'store-access',
            'seat-list-type',
            'seat-register-type',
            'setting-store',
            'setting-banner',
            'plan',
            'floor',
            'card',
            'product-price',
            'user',
            'receipt',
            'customer-type-register',
            'user',
            'receipt',
            'category',
            'history-monthly',
            'equipment',
            'business-day',
            'profile',
            'print-setting',
            'discount-report',
            'card-report',
            'room',
            'authenticate-setting',
            'printer',
            'response',
            'validateMessage',
            'validateName',
            'work-manage',
            'edit-history-by-month',
            'slip-edit-history',
            'current-exchange',
            'product-daily-report',
            'stock-history',
            'app-function',
            'smart-phone-customer',
            'remove-account',
        ],
        backend: {
            loadPath: '/assets/i18n/{{ns}}/{{lng}}.json',
        },
        react: { useSuspense: true },
    });

export default i18n;
